/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetRecruitmentQueryResponse, GetRecruitmentQueryParams, GetRecruitment400 } from '../entities/GetRecruitment'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getRecruitment } from '../api/getRecruitment'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getRecruitmentQueryKey = (params: GetRecruitmentQueryParams) => [{ url: '/recruitment' }, ...(params ? [params] : [])] as const

export type GetRecruitmentQueryKey = ReturnType<typeof getRecruitmentQueryKey>

export function getRecruitmentQueryOptions(params: GetRecruitmentQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getRecruitmentQueryKey(params)
  return queryOptions<GetRecruitmentQueryResponse, ResponseErrorConfig<GetRecruitment400>, GetRecruitmentQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getRecruitment(params, config)
    },
  })
}

/**
 * @description Получение вербовок таксопарка
 * @summary Получение вербовок таксопарка
 * {@link /recruitment}
 */
export function useGetRecruitment<
  TData = GetRecruitmentQueryResponse,
  TQueryData = GetRecruitmentQueryResponse,
  TQueryKey extends QueryKey = GetRecruitmentQueryKey,
>(
  params: GetRecruitmentQueryParams,
  options: {
    query?: Partial<QueryObserverOptions<GetRecruitmentQueryResponse, ResponseErrorConfig<GetRecruitment400>, TData, TQueryData, TQueryKey>> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getRecruitmentQueryKey(params)

  const query = useQuery(
    {
      ...(getRecruitmentQueryOptions(params, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetRecruitment400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}